import { forwardRef, type ButtonHTMLAttributes } from 'react'

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant
  isLoading?: boolean
}

const VARIANT_CLASSES: Record<Variant, string> = {
  primary: 'bg-primary-container text-on-primary hover:opacity-95 shadow-sm',
  secondary:
    'bg-transparent border border-outline-variant text-on-surface hover:bg-surface-container-high',
  ghost: 'bg-transparent text-on-surface-variant hover:bg-surface hover:text-on-surface',
  danger: 'bg-error text-on-error hover:opacity-90 shadow-sm',
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'primary', isLoading, disabled, className = '', children, ...props }, ref) => {
    return (
      <button
        ref={ref}
        disabled={disabled || isLoading}
        className={`inline-flex h-10 items-center justify-center gap-space-xs rounded-lg px-space-md font-label-md text-label-md transition-all disabled:cursor-not-allowed disabled:opacity-60 ${VARIANT_CLASSES[variant]} ${className}`}
        {...props}
      >
        {isLoading && (
          <span className="material-symbols-outlined animate-spin text-lg">progress_activity</span>
        )}
        {children}
      </button>
    )
  },
)

Button.displayName = 'Button'
